<template>
  <div class="tab-pane fade" id="tabb3" role="tabpanel" aria-labelledby="tabb-3">
    <table class="table table-sm">
      <thead>
      <tr>
        <th scope="col">Gruppenname</th>
        <th scope="col">Feldname</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody v-for="(group, i) in fieldsGroups" :key="i" v-if="group.deleted  !== 1">
      <tr @click="makeGroupEditable($event,i)" :class="{active_tr: activeGroup === i}">
        <td class="pt-1">
          <div class="form-row">
            <i class="fa fa-circle dot-color d-inline mt-1"></i>
            <div class="custom-control custom-checkbox circle-checkbox">
              <input v-if="activeGroup === i" type="text" class="text-capitalize font-weight-bold" v-model="group.crgroupname" :class="{'group-input': activeGroup === i}" data-value="btn">
              <input v-else type="text" class="text-capitalize font-weight-bold" v-model="group.crgroupname" :class="{'group-input': activeGroup === i}" readonly>
            </div>
          </div>
        </td>
        <td><i class="d-none">{{group.crgrouporder = i}}</i></td>
        <td></td>
        <td>
          <div class="udarrow" v-visible="activeGroup === i">
            <small @click="groupMoveUp(i)" data-value="btn" class="pr-1" v-if="i">
              <img src="@/assets/images/up_icon.png" alt="remove" width="25">
            </small>
            <small @click="groupMoveDown(i)" data-value="btn" v-if="fieldsGroups.length !== (i + 1)">
              <img src="@/assets/images/down_icon.png" alt="remove" width="25">
            </small>
          </div>
          <a href="javascript:void(0)" @click="removeGroup(i)" class="udrem" data-value="btn" v-if="activeGroup === i">
            <img src="@/assets/images/delete_icon.png" alt="remove" width="24">
          </a>
        </td>
      </tr>


      <tr v-for="(value,index) in group.groupvalues" :key="index" :class="{active_tr : `${index}${i}` === activeIndex}" @click="makeFieldsEditable($event,`${index}${i}`)">
        <th scope="row">
          <i class="d-none">{{ value.crgroupfieldorder = index }}</i>
        </th>
        <td>
          <div class="form-row">
            <div class="col-auto">
              <div class="custom-control custom-checkbox circle-checkbox">
                <i class="fa fa-circle dot-color pt-1"></i>
              </div>
            </div>
            <div class="col-auto">
              <input v-if="`${index}${i}` === activeIndex" type="text" v-model="value.crgroupfieldname" class="form-control input-style" data-value="btn">
              <input v-else type="text" v-model="value.crgroupfieldname" class="form-control input-style" readonly>
            </div>
          </div>
        </td>
        <td style="min-width : 5rem">
          <div class="udarrow" v-visible="`${index}${i}` === activeIndex">
            <small @click="moveUp(index,group,i)" data-value="btn" v-if="index">
              <img src="@/assets/images/up_icon.png" alt="remove" width="25">
            </small>
            <small @click="moveDown(index,group,i)" data-value="btn" v-if="group.groupvalues.length !== (index + 1)">
              <img src="@/assets/images/down_icon.png" alt="remove" width="25">
            </small>
          </div>
          <a href="javascript:void(0)" @click="removeField(index,group)" class="udrem" data-value="btn" v-visible="`${index}${i}` === activeIndex">
            <img src="@/assets/images/delete_icon.png" alt="remove" width="24">
          </a>
        </td>
      </tr>

      <tr>
        <td></td>
        <td colspan="3">
          <a class="settingbuttons" @click="addNewFieldInGroup(group)">
            <i class="fa fa-plus pr-1" aria-hidden="true"></i>
            Feld hinzufügen
          </a>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td>
          <button class="settingbuttons mt-2" @click="addNewGroup">
            <i class="fa fa-plus pr-1"></i> Gruppe hinzufügen
          </button>
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
export default {
  data(){
    return {
      activeIndex : null,
      activeGroup : null,
    }
  },
  computed : {
    fieldsGroups: {
      get(){
        return this.$store.state.appSettings.fieldsGroups
      },
      set(groups){
        this.$store.commit("setFieldsGroups",groups)
      }
    }
  },
  methods : {
    addNewFieldInGroup(group){
      let fieldData = {
        constructionreportid: null,
        crgroupfieldid: 0,
        crgroupfieldname: '',
        crgroupfieldorder: 0,
        crgroupfieldvalue: null,
        crgroupfieldvalueid: null,
        crgroupid: group.crgroupid,
        done: null,
        jsonparams: null,
        _explicitType: "com\\projectdocu\\CRGroupFieldValueVO"
      };
      group.groupvalues.push(fieldData);
    },

    addNewGroup () {
      let group = {
        crgroupid: 0,
        deleted: 0,
        projectid: this.$route.params.id,
        crgroupname: 'Gruppenname',
        crgrouporder: 0,
        groupvalues: [],
        _explicitType: 'com\\projectdocu\\CRGroupVO'
      }
      this.fieldsGroups.push(group);
      this.activeGroup = this.fieldsGroups.length - 1;
      this.activeIndex = null;
    },

    makeGroupEditable(e,index){
      let element = e.target.getAttribute('data-value');
      let tag = e.target.tagName;
      if(element !== "btn" && tag !== 'IMG'){
        this.activeGroup = index === this.activeGroup ? null : index;
        this.activeIndex = null;
      }
    },

    //Move the group Up one step by clicking the Up arrow
    groupMoveUp(from){
      let groups = this.fieldsGroups;
      if (from > 0){
        let to = from - 1;
        this.moveIndex(groups,from , to,true)
      }
    },

    //Move the group down by clicking the down arrow
    groupMoveDown(from){
      let groups = this.fieldsGroups;
      if (from < groups.length){
        let to = from + 1;
        this.moveIndex(groups,from , to,true)
      }
    },

    //function to remove Group
    removeGroup(index){
      this.fieldsGroups[index].deleted = 1;
    },

    //function to remove Group
    removeField(index,group){
      group.groupvalues.splice(index,1);
    },

    makeFieldsEditable(e,index){
      let element = e.target.getAttribute('data-value');
      if(element !== "btn" && e.target.tagName !== 'IMG'){
        this.activeIndex = index === this.activeIndex ? null : index;
        this.activeGroup = null;
      }
    },
    //Move the fields Up one step by clicking the Up arrow
    moveUp(from,group,i){
      if (from > 0){
        let to = from - 1;
        this.activeIndex = `${to}${i}`
        this.moveIndex(group,from , to)
      }
    },

    //Move the fields down by clicking the down arrow
    moveDown(from,group,i){
      if (from < group.groupvalues.length){
        let to = from + 1;
        this.activeIndex = `${to}${i}`
        this.moveIndex(group,from , to)
      }
    },
  //function for moving the indexes
    moveIndex(groups,from, to,is_group = false) {
      is_group ? this.activeGroup = to : '';
      let items = is_group ? groups : groups.groupvalues
      let numberOfDeletedElm = 1;
      const elm = items.splice(from, numberOfDeletedElm)[0];
      numberOfDeletedElm = 0;
      items.splice(to, numberOfDeletedElm, elm);
    }
  }
}
</script>
<style scoped>
.btnw,.udarrow small,.udrem{
  cursor: pointer;
  z-index: 1000;
  font-size: 1rem;
}
.active_tr{
  background: lightgray;
  z-index: 10;
}
.circle-checkbox .custom-control-label {
  position: absolute;
}
input.group-input{
  border: 1px solid #ccc;
  padding: 4px;
  width: 100%;
  border-radius: 3px;
  height: auto;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/SettingsFieldsTab.vue